import { SxProps, Theme } from "@mui/system";

export const sectionTitle: SxProps<Theme> = {
  borderBottom: "3px solid black",
  fontSize: "11px",
  fontWeight: 500,
  fontFamily: "Inter",
  padding: "3px",
};

export const bodyText: SxProps<Theme> = {
  fontSize: "10px",
  fontFamily: "Inter",
  lineHeight: 1.8,
};

export const clientDetailText: SxProps<Theme> = {
  fontSize: "10px",
  fontFamily: "Inter",
  lineHeight: 1.8,
};

export const bankDetailText: SxProps<Theme> = {
  fontSize: "10px",
  fontFamily: "Inter",
  lineHeight: 2,
};

export const labelText: SxProps<Theme> = {
  fontSize: "10px",
  fontWeight: 500,
};
